import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'productAttributes',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getProductAttributesSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllProductAttributesSuccess(state, action) {
      state.allData = action.payload.data;
    },

    addOrUpdateProductAttributes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllProductAttributes() {
  return async () => {
    try {
      const response = await get(`product-attribute`);
      if (response.status) {
        dispatch(slice.actions.getAllProductAttributesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getProductAttributesForEdit() {
  return async () => {
    try {
      const response = await get(`product-attribute`);
      if (response.status) {
        dispatch(slice.actions.getProductAttributesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getProductAttributes() {
  return async () => {
    try {
      const response = await get(`product-attribute`);
      if (response.status) {
        dispatch(slice.actions.getProductAttributesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addProductAttributes(body) {
  return async () => {
    try {
      const response = await post(`product-attribute`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductAttributes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateProductAttributes(body) {
  return async () => {
    try {
      const response = await put(`product-attribute/${body.id}`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductAttributes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
